<div class="mmapsFooter">
  <div class="rowNoMargins" style="margin-right: 0;">
    <div class="footerText">© Duke Energy Corporation. All Rights Reserved.</div>
  </div>
</div>